import { c as _c } from "react/compiler-runtime";
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { styled, type Theme } from '@mui/material';
import { BaseIcon } from './BaseIcon';
import { IconProps } from './types';
export const User = t0 => {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      variant: "normal",
      weight: "normal"
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onClick,
    variant,
    weight
  } = t1;
  const Icon = variant === "outlined" ? PersonOutlineIcon : PersonIcon;
  if (weight === "muted") {
    let t2;
    if ($[2] !== Icon || $[3] !== onClick) {
      t2 = <MutedIcon Icon={Icon} onClick={onClick} />;
      $[2] = Icon;
      $[3] = onClick;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== Icon || $[6] !== onClick) {
    t2 = <PrimaryIcon Icon={Icon} onClick={onClick} />;
    $[5] = Icon;
    $[6] = onClick;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const MutedIcon = styled(BaseIcon, {})(({
  theme
}: {
  theme: Theme;
}) => ({
  cursor: 'pointer',
  color: theme.palette.grey[200]
}));
const PrimaryIcon = styled(BaseIcon, {})(({
  theme
}: {
  theme: Theme;
}) => ({
  cursor: 'pointer',
  color: theme.palette.primary.main
}));